var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminPolicies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8020_8777)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8020_8777",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8020_8777)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8020_8777)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8020_8777",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5H5V19H19V5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8020_8777)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8020_8777",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5H5V19H19V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8020_8777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2501 12C17.25 11.6781 17.2207 11.357 17.1626 11.0404L18.9376 10.0167L17.1876 6.98333L15.412 8.00941C14.9218 7.58995 14.3583 7.26446 13.7501 7.04925V5H10.2501V7.04925C9.64181 7.26446 9.07843 7.58995 8.58816 8.00941L6.8125 6.98333L5.0625 10.0167L6.83758 11.0404C6.72098 11.6748 6.72098 12.3252 6.83758 12.9596L5.0625 13.9833L6.8125 17.0167L8.58816 15.9911C9.07848 16.4104 9.64186 16.7357 10.2501 16.9508V19H13.7501V16.9508C14.3583 16.7355 14.9218 16.41 15.412 15.9906L17.1876 17.0167L18.9376 13.9833L17.1626 12.9596C17.2207 12.643 17.25 12.3219 17.2501 12ZM13.7501 12C13.7501 12.3461 13.6474 12.6845 13.4552 12.9722C13.2629 13.26 12.9895 13.4843 12.6698 13.6168C12.35 13.7492 11.9981 13.7839 11.6587 13.7164C11.3192 13.6489 11.0074 13.4822 10.7626 13.2374C10.5179 12.9927 10.3512 12.6809 10.2837 12.3414C10.2162 12.0019 10.2508 11.6501 10.3833 11.3303C10.5157 11.0105 10.74 10.7372 11.0278 10.5449C11.3156 10.3526 11.654 10.25 12.0001 10.25C12.4642 10.25 12.9093 10.4344 13.2375 10.7626C13.5657 11.0908 13.7501 11.5359 13.7501 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 13.1666C12.6445 13.1666 13.1668 12.6443 13.1668 11.9999C13.1668 11.3556 12.6445 10.8333 12.0002 10.8333C11.3558 10.8333 10.8335 11.3556 10.8335 11.9999C10.8335 12.6443 11.3558 13.1666 12.0002 13.1666Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8020_8777",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8020_8777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPolicies);
export default __webpack_public_path__ + "static/media/Admin-Policies.00adf6cab5193cd5ca2208c54cae6822.svg";
export { ForwardRef as ReactComponent };